import { render, staticRenderFns } from "./BrowserPaying.vue?vue&type=template&id=63671b22&scoped=true&"
import script from "./BrowserPaying.vue?vue&type=script&lang=js&"
export * from "./BrowserPaying.vue?vue&type=script&lang=js&"
import style0 from "./BrowserPaying.vue?vue&type=style&index=0&id=63671b22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63671b22",
  null
  
)

export default component.exports